import { errorMessagesSection, FormStyle, infoPlaceholderSection, React, SelectStyle } from "@/imports-files/components/custom-select";
import TextInput from 'react-autocomplete-input';
import { MentionsInput, Mention } from 'react-mentions'

export function CustomTextInputSuggestion(props)
{

  return(
       <div className= {'autosuggestTextInput'}>
            
           <MentionsInput singleLine={true} {...props} >
                <Mention
                  markup="[__display__]{__id__}"
                  data={props.options}
                />
            </MentionsInput>
            
           {
             props.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik, props.custom_class || '')
                                      :  infoPlaceholderSection(props.infoPlaceholder, FormStyle)
           }

       </div>
     )
}

